var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_14787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50012 14.5H10.5001",
    stroke: "#4B4AD5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91883 10.437C4.32443 9.97268 3.84299 9.37969 3.51067 8.70259C3.17834 8.02549 3.00377 7.28189 3.00008 6.52764C2.98508 3.81764 5.17008 1.56201 7.87945 1.49951C8.92946 1.47408 9.96081 1.77995 10.8272 2.37373C11.6935 2.9675 12.3509 3.81903 12.7061 4.80748C13.0612 5.79594 13.096 6.87113 12.8056 7.8805C12.5152 8.88987 11.9143 9.78216 11.0882 10.4308C10.906 10.572 10.7583 10.753 10.6564 10.9598C10.5545 11.1666 10.5011 11.3939 10.5001 11.6245V11.9995C10.5001 12.1321 10.4474 12.2593 10.3536 12.3531C10.2599 12.4468 10.1327 12.4995 10.0001 12.4995H6.00008C5.86747 12.4995 5.74029 12.4468 5.64652 12.3531C5.55276 12.2593 5.50008 12.1321 5.50008 11.9995V11.6245C5.49984 11.3954 5.44736 11.1694 5.34664 10.9636C5.24592 10.7578 5.09961 10.5777 4.91883 10.437Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50012 3.5C9.75012 3.71062 10.7882 4.75 11.0001 6",
    stroke: "#4B4AD5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_14787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.81996201791bde89bed87c079c677d97.svg";
export { ForwardRef as ReactComponent };